import { useEffect } from 'react';
import { Envelope } from '@gravity-ui/icons';
import { Link } from '@gravity-ui/uikit';

import { useNavigateReplace } from 'hooks';
import { routes } from 'routes';

import {
	ADMIN_REG,
	ADMINISTRATOR,
	EMAIL,
	HELP_INFO,
	LETTER_SENT,
	MESSAGE_TEXT_EMAIL,
	MESSAGE_TEXT_PASSWORD,
	PASSWORD_PROBLEM,
} from '../constants';

import styles from './styles.module.scss';

type InfoMessageProps = {
	passRecovery?: boolean;
	userRegistration?: boolean;
	value: string;
};

export const InfoMessage = ({ userRegistration, passRecovery, value }: InfoMessageProps) => {
	const navigate = useNavigateReplace();

	useEffect(() => {
		setTimeout(() => {
			navigate(routes.login.path);
		}, 7000);
	}, [navigate]);

	return (
		<div className={styles.info}>
			<Envelope className={styles.info__icon} />
			<h3>{LETTER_SENT}</h3>

			{passRecovery && (
				<>
					<p className={styles.info__message}>{MESSAGE_TEXT_PASSWORD + value}</p>
					<p className={styles.info__problem}>{PASSWORD_PROBLEM}</p>
				</>
			)}

			{userRegistration && (
				<>
					<p className={styles.info__message}>{MESSAGE_TEXT_EMAIL + value}</p>
					<p className={styles.info__problem}>{HELP_INFO}</p>
				</>
			)}

			<div className={styles.info__help}>
				{passRecovery && ADMINISTRATOR}
				{userRegistration && ADMIN_REG}
				<Link view="normal" href="#">
					{EMAIL}
				</Link>
			</div>
		</div>
	);
};
